<template>
<div class="nav-item-wrapper">
  <KitchenDrawerNavItem v-for="item in drawerNavItems" :key="item.title" :item="item" @select-content="onSelectContent" />
</div>
</template>

<script>
import store from '@state/store';
import { kitchenDrawerNavItemMixin } from 'kitchenDrawerNavItemMixin';
import { shareMixin } from 'shareMixin';
import KitchenDrawerNavItem from './KitchenDrawerNavItem';
import { kitchenDrawerMethods } from '@state/helpers';

export default {
  mixins: [kitchenDrawerNavItemMixin, shareMixin],
  components: {
    KitchenDrawerNavItem,
  },
  props: {
    isEmbed: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    drawerNavItems() {
      return this.getDrawerNavItems();
    },
  },
  mounted() {},
  methods: {
    ...kitchenDrawerMethods,
    async onSelectContent(item) {
      await this.navigateDeeper(item);
      if (item.component === 'Plans') {
        this.updateShareableUrl(item.component);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.nav-item-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 2rem 1rem 0;
}
</style>
